<template>
  <div
    class="progress-bar h-4 w-full overflow-hidden rounded-lg bg-green-400 bg-gradient-to-r from-green-400 to-green-500"
  >
    <div class="progress-loading h-full w-full" />
  </div>
</template>
<script lang="ts" setup></script>
